<template>
    <div class='recommended-cart-products-container' id='recommended_cart_products_container'>
        <Button @click='continueToCheckout' text='continue to checkout' theme='dark' :disabled='total_items == 0'/>
        <div class='header-section'>
            <div class='recommended-products-title'>Recommended Products</div>
            <div @click='returnToBasket'>
                <span class="fa-layers fa-fw basket-icon">
                    <i class="fa-light fa-bag-shopping"></i>
                    <span class="fa-layers-counter basket-counter">{{total_items}}</span>
                </span>
            </div>
        </div>

        <div class='products-container'>
            <div v-for='product in products' :key='product.code'>
                <DynamicImageContainer @click='openProduct(product.code)' class="product-image" :image='product.main_picture' :image_on_hover='product.second_picture' :show_different_image_on_hover='false' />
                <div class='heading'>{{product.product}}</div>
                <div class='price'>£{{product.price}}</div>
                <Button @click='openProduct(product.code)' text='Add to bag' theme='dark'/>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/ecom/components/buttons/Button.vue';
import {checkAuth} from "@/global/modules/functions.js";
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components: {Button, DynamicImageContainer},
    props: ['total_items'],
    emits: ['continueToCheckoutListener', 'returnToBasketListener', 'viewProductListener'],
    data(){
        return{
            products: []
        }
    },
    methods:{
        continueToCheckout(){
            this.$emit('continueToCheckoutListener')
        },
        returnToBasket(){
            this.$emit('returnToBasketListener')
        },
        async getRecommendedProducts(){
            // this.loading = true;
            let response = await fetch(`/api/elastic-search/products?search_string=dress&search_type=fuzzy&start_index=0&fetch_next=10`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.products = results.products;
                this.loading = false;
                // this.$emit('selectedCarouselTypeListener', this.products);
            }
        },
        openProduct(code){
            this.$emit('viewProductListener', code);
        }
    },
    mounted(){
        this.getRecommendedProducts();
    }
}
</script>

<style lang="scss" scoped>
.recommended-cart-products-container{
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 28px;
    margin-bottom: 200px;
}

.header-section{
    display: flex;
    justify-content: space-between;
}

.recommended-products-title{
    font-size: 1.1rem;
    font-weight: 500;
}

.basket-icon{
    font-size: 1.4rem;
    cursor: pointer;
}

.basket-counter{
    font-size: 2.6rem;
    background-color: var(--primary-colour-1);
    margin-right: -3px;
    margin-top: -3px;
}

.product-image{
    object-fit: cover;
    object-position: 50% 0;
    width: 204px;
    height: 300px;
    cursor: pointer;
}

.products-container{
    display: flex;
    flex-wrap: wrap;
    gap: 24px 12px;
    align-content: center;
}

.heading{
    font-size: 0.9rem;
    font-weight: 400;
    max-width: 200px;
    text-align: center;
}

.price{
    font-size: 0.91em;
    font-weight: 600;
    text-align: center;
    margin-top: 16px;
    margin-bottom: 16px;
}

</style>